import { SubscriptionOutput } from '@allocab/allocab-driver-service-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const finishSubscription = (subscriptionId: string) =>
  driverApi.patch<void, SubscriptionOutput>(`/v1/subscription/${subscriptionId}/finish`);

const useFinishSubscription = () =>
  useMutation<SubscriptionOutput, unknown, string>({
    mutationFn: finishSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.user.me());
    },
  });

export default useFinishSubscription;
